import React, { useContext, useEffect } from 'react';
import { FaInfoCircle } from 'react-icons/fa';
import ReactTooltip from 'react-tooltip';
import { CotizadorCRDataContext } from '../../context/CotizadorCRDataContext';
import { estadoCivil, sexo, tipoDocumentos, motivoRechazoCICAC } from '../../data/mochaData';
import useToken from '../../hooks/useToken';
import { amaDeCasa, estudiante, tipoId } from '../../utils/constanst';
import CustomSelect from '../controls/CustomSelect';
import DateControl from '../controls/DateControl';
import DropDownInput from '../controls/DropDownInput';
import Input from '../controls/Input';
import InputFile from '../controls/InputFile';
import InputSelect from '../controls/InputSelect';
import SwitchButton from '../controls/SwitchButton';
import RadioButton from '../controls/RadioButton';

const Step6 = ({ ...rest }) => {



    const { poliza, setPoliza, polizaChangeHandler } = useContext(CotizadorCRDataContext);

    const changeChk = (property, value) => setPoliza({ ...poliza, [property]: value });


    return (
        <div>
            <div className="reponsive">
                <div className="reponsive-width-12">
                    <h5>Informacion Ley FATCA/CRS
                        <FaInfoCircle color="#E1E1E1" data-tip='La Ley sobre el Cumplimiento Fiscal relativa a Cuentas en el Extranjero (FATCA) Estándar Común de Comunicación (CRS)' data-html={true} />
                    </h5>
                </div>

                <div className="reponsive-width-12 d-flex-bottom">
                    <div className="reponsive-width-6">
                        <div className="box-pl5-pr5">
                            <SwitchButton label="¿El cliente es contribuyente de impuestos en los Estados Unidos o sus territorios (FATCA)?" value={poliza.kycIsFacta} onClick={value => setPoliza({ ...poliza, kycIsFacta: value })} />
                        </div>
                    </div>
                    <div className="reponsive-width-6">
                        <div className="box-pl5-pr5">
                            <Input label='TIN (Tax, Identificacion, Number)' required={poliza.kycIsFacta} field='kycTIN' value={poliza.kycTIN} onChange={polizaChangeHandler} />
                        </div>
                    </div>
                </div>

                <div className="reponsive-width-12 d-flex-bottom">
                    <div className="reponsive-width-6">
                        <div className="box-pl5-pr5">
                            <SwitchButton label="¿El cliente es contribuyente de impuestos en países diferentes a Costa Rica, Estados Unidos y sus territorios (CRS)?" value={poliza.kycIsCRS} onClick={value => setPoliza({ ...poliza, kycIsCRS: value })} />
                        </div>
                    </div>
                    <div className="reponsive-width-6">
                        <div className="box-pl5-pr5">
                            <Input label='País de Domicilio Fiscal (FATCA/CRS)' required={poliza.kycIsCRS} field='kycPDF' value={poliza.kycPDF} onChange={polizaChangeHandler} />
                        </div>
                    </div>
                </div>

                <div className="reponsive-width-12 d-flex-bottom">
                    <div className="reponsive-width-6">
                        <div className="box-pl5-pr5">
                            <SwitchButton label="¿Tiene el cliente alguna nacionalidad estadounidense o de sus territorios?" value={poliza.kycHasNE} onClick={value => setPoliza({ ...poliza, kycHasNE: value })} />
                        </div>
                    </div>
                    <div className="reponsive-width-6">
                        <div className="box-pl5-pr5">
                            <Input label='Dirección del domicilio fiscal (FATCA/CRS)' required={poliza.kycHasNE} field='kycDDF' value={poliza.kycDDF} onChange={polizaChangeHandler} />
                        </div>
                    </div>
                </div>

                <div className='reponsive-width-12 d-flex-bottom'>
                    <div className="reponsive-width-6">
                        <div className="box-pl5-pr5">
                            <SwitchButton label="¿Tiene el cliente alguna nacionalidad en un país con convenio de transparencia tributaria con Costa Rica?" value={poliza.kycHasNCTT} onClick={value => setPoliza({ ...poliza, kycHasNCTT: value })} />
                        </div>
                    </div>
                    <div className="reponsive-width-6">
                        <div className="box-pl5-pr5">
                            <Input label='Justificación No posee TIN (CRS)' required={poliza.kycHasNCTT} field='kycJNTIN' value={poliza.kycJNTIN} onChange={polizaChangeHandler} />
                        </div>
                    </div>
                </div>


                <div className="reponsive-width-12 d-flex-bottom">
                    <h5>Sujetos obligados y PEP
                        <FaInfoCircle color="#E1E1E1" data-tip='Personas Expuestas Políticamente (PEP)' data-html={true} />
                    </h5>
                </div>

                <div className="reponsive-width-6">
                    <div className="box-pl5-pr5">
                        <SwitchButton label="¿Es el cliente sujeto obligado de inscripción ante SUGEF según los artículos 15 y 15 bis de la Ley 8204?" value={poliza.kycHasSUGEF} onClick={value => setPoliza({ ...poliza, kycHasSUGEF: value })} />
                    </div>
                </div>

                <div className="reponsive-width-6">
                    <div className="box-pl5-pr5">
                        <SwitchButton label="¿Ocupa o ha ocupado el cliente o su cónyuge un cargo público en los últimos 12 años? ¿En caso afirmativo, favor detalle el cargo, el período?" value={poliza.kycHasPEP} onClick={value => setPoliza({ ...poliza, kycHasPEP: value })} />
                    </div>
                </div>

            </div>
            <br />
            <br />
            <div className='reponsive-width-12' style={{ background: '#D9D9D9', marginTop: 35, fontWeight: 600, height: 30 }}>
                <div style={{ display: "flex", justifyContent: 'center', height: '100%', alignItems: 'center' }}>
                    INFORMACIÓN CICAC
                </div>
            </div>
            <div className='reponsive-width-12' style={{ textAlign: 'justify', fontSize: 14, background: '#F4F4F4' }}>
                El Cliente, manifiesta conocer y aceptar en forma expresa, que ha recibido información necesaria y explicación previa, respecto al objeto, alcance, funcionamiento, acceso y uso de la información del Centro de Información Conozca a su Cliente (CICAC). Que este constituye un expediente electrónico que recopila y almacena la información como insumo básico para la atención de la política conozca a su cliente, Asimismo, declara entender, que los sujetos obligados, supervisados por las superintendencias adscritas en el Consejo Nacional de Supervisión del Sistema Financiero (CONASSIF), pueden tener acceso al CICAC, siempre y cuando exista una autorización previa por
                parte del titular de la información, Por lo tanto:
            </div>

            <div className="reponsive-width-12 " style={{ fontSize: 14 }}>
                <div className="reponsive-width-8" >
                    <p>
                        ¿En su condición de cliente y titular de la información, acepta que su información sea inclinada en el centro de información conozca a su cliente (CICAC) En caso negativo favor indicar el motivo
                    </p>
                </div>
                <div className="reponsive-width-4">
                    <div className="box-pl5-pr5">
                        <RadioButton field={'aceptaCICAC'} isRequired={true} key={'aceptaCICAC'} onChange={changeChk} isCheked={poliza.aceptaCICAC} />
                    </div>
                </div>
            </div>
            {poliza.aceptaCICAC === false &&
                <div className="reponsive-width-12" style={{ fontSize: 14 }}>
                    <div className='reponsive-width-4' style={{ fontSize: 14 }}>
                        <p>Favor indicar el motivo de rechazo</p>
                    </div>
                    <InputSelect required={!poliza.aceptaCICAC} label='' field='motivoid' value={poliza.motivoid} dataProvider={motivoRechazoCICAC} onChange={polizaChangeHandler} containBlank={true} />
                </div>
            }

            {poliza.aceptaCICAC === false && poliza.motivoid === '4' &&
                <>                 
                    <div className="reponsive-width-12" style={{ fontSize: 14 }}>
                        <div className='reponsive-width-4'>
                            <p>Comentarios</p>
                        </div>
                        <div className='reponsive-width-8'>
                            <Input type='textarea' field='comentariosCICAC' id='comentariosCICAC' value={poliza.comentariosCICAC} isRequired={!poliza.aceptaCICAC} onChange={polizaChangeHandler} />
                        </div>
                    </div>
                </>
            }

            <ReactTooltip className='tipstyle' multiline={true} />
        </div>

    );
}

export default Step6;
